module.exports = __webpack_public_path__ + "static/media/big-lucky-vertical-green-bg-gold-white-400x240.2781ba59.png";